module.exports = __webpack_public_path__ + "img/inspect.3fc73013.png";